import React, {useState} from "react";
import {
    Create,
    FormTab,
    TextInput,
    TabbedForm,
    Toolbar,
    ReferenceInput,
    NumberInput
} from 'react-admin';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from "@material-ui/core";
import SaveIcon from '@material-ui/icons/Save';
import ComboUnidadNegocio from "../componentes/ComboUnidadNegocio";


const useStyles = makeStyles((theme) => ({
    emisora: {display: 'inline-block', width: 200, marginLeft: 8},
    emisora_d: {display: 'inline-block', width: 400, marginLeft: 8},
}));

const PostCreateToolbar = props => {
    return (
        <Toolbar {...props} >

        </Toolbar>
    )

};

const validateCreate = (values) => {
    const errors = {};

    var w_emisora = values.emisora

    if (w_emisora===undefined) {
        errors.emisora = ['El campo Código es requerido'];
    }else {
        if (w_emisora === null) {
            errors.emisora = ['El campo Código es requerido'];
        } else {
            w_emisora = w_emisora.trim()
            if (w_emisora === '') {
                errors.emisora = ['El campo Código es requerido'];
            }
        }
    }


    var w_emisora_d = values.emisora_d

    if (w_emisora_d===undefined) {
        errors.emisora_d = ['El campo Descripcion es requerido'];
    }else {
        if (w_emisora_d === null) {
            errors.emisora_d = ['El campo Descripcion es requerido'];
        } else {
            w_emisora_d = w_emisora_d.trim()
            if (w_emisora_d === '') {
                errors.emisora_d = ['El campo Descripcion es requerido'];
            }
        }
    }


    return errors
};

// redirect to the related Author show page
const redirect = (basePath, id, data) => `/UnidadEmisora`;

const UnidadEmisoraCreate = props => {
    const classes = useStyles();

    const PostTitle = ({record}) => {
        return <span>Alta de Unidad Emisora</span>;
    };

    return (
        <Create title={<PostTitle/>} {...props}>
            <TabbedForm
                // toolbar={<PostCreateToolbar />} validate={validateCreate} redirect={redirect}
            >
                {/*Datos*/}
                <FormTab label="DATOS UNIDAD EMISORA">

                    <ComboUnidadNegocio readOnly={false}/>

                    <TextInput
                        label="Código Unidad Emisora"
                        source="emisora"
                        formClassName={classes.emisora}
                        placeholder="Ingrese Código Unidad Emisora"
                        helperText="Código"
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="outlined"
                    />

                    <br/>

                    <TextInput
                        id="standard-full-width"
                        label="Descripción Unidad Emisora"
                        source="emisora_d"
                        formClassName={classes.emisora_d}
                        multiline
                        placeholder="Ingrese Descripcion Unidad Emisora"
                        helperText="Descripcion"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="outlined"
                    />
                    <br/>

                </FormTab>
            </TabbedForm>
        </Create>
    )
};
export default UnidadEmisoraCreate;


